const messages = {
  message: {
    appTitle: 'Reclame su equipaje',
    headerLogoAlt: 'Damaged luggage',
    headerEmailIconAlt: 'Mándenos un correo electrónico',
    backButton: 'Atrás',
    nextButton: 'Continuar',
    deleteButton: 'Eliminar',
    cancelButton: 'Cancelar',
    yesButton: 'Sí',
    noButton: 'No',
    backToStart: 'Volver al inicio',
    chatTitle: '',
    chatSubTitle: '',
    datePlaceholderText: 'Seleccionar fecha',
    selectPlaceholderText: 'Seleccionar',
    formErrorTitle: 'Error en el formulario',
    formErrorMessage: 'Por favor, solucione cualquier error en el formulario para continuar',
    gdpr: {
      nextButtonText: 'Continuar con la reclamación'
    },
    claimType: {
      title: '¿Cómo podemos ayudar?'
    },
    dataPreparation: {
      completeFormSentence: 'Por favor, asegúrese de haber rellenado un formulario de aduanas y envíelo en el recuadro a su derecha.',
      airportDeliverySentence: 'Sin una declaración de aduanas cumplimentada no podremos retirar su equipaje del aeropuerto para organizar la entrega.',
      pleaseContinue: 'Una vez cumplimentado, haga clic en Siguiente para continuar.',
    },
    boardingPassScan: {
      scanToGetStarted: 'Escanee su tarjeta de embarque para empezar',
      pleaseScanDescriptionText: 'Escanee el código de barras o el código QR de su tarjeta de embarque para iniciar el proceso de reclamación.',
      noBoardingPass: '¿No tiene tarjeta de embarque?',
      enterFlightDetailsManually: 'Introduzca manualmente los datos del vuelo'
    },
    boardingPassConfirm: {
      weFoundFollowingDetails: 'Encontramos los siguientes datos',
      name: 'Nombre',
      flightNumber: 'N.º de vuelo',
      dateOfFlight: 'Fecha de vuelo',
      departureAirport: 'Aeropuerto de salida',
      arrivalAirport: 'Aeropuerto de llegada',
      areAboveDetailsCorrect: '¿Son correctos los datos de arriba?',
      yesProceedButton: 'Sí, continúe.',
      noScanAgainButton: 'No, escanee de nuevo',
      enterFlightDetailsManually: 'Introduzca manualmente los datos del vuelo'
    },
    about: {
      title: 'Sus datos',
      firstName: 'Nombre',
      surname: 'Apellido',
      emailAddress: 'Correo electrónico',
      phoneNumber: 'Teléfono',
      phoneNumber2: 'Teléfono 2',
      country: 'País',
      fiscalCode: 'Código fiscal',
      address: 'Dirección',
      addressLine1: 'Dirección',
      addressLine2: 'Dirección (continuación)',
      addressLine3: 'Dirección (continuación)',
      nameOnDoorBuzzer: 'Nombre en el timbre de la puerta',
      city: 'Ciudad',
      county: 'Población',
      postcode: 'Código postal',
      selectAddressPlaceholderText: 'Seleccionar dirección',
      searchDifferentAddress: 'Buscar una dirección diferente',
      manualAddress: 'Introducir dirección manualmente',
      editAddress: 'Editar la dirección'
    },
    address: {
      homeAddressTitle: 'Domicilio',
      tempAddressTitle: 'Dirección de visita',
      differentAddress: '¿Está de visita actualmente en una dirección temporal?',
      dateTempAddress: 'Última fecha en la dirección temporal',
      plannedTravel: '¿Tiene planeado viajar pronto?',
      plannedTravelDate: '¿Cuándo tiene previsto viajar?'
    },
    flightDetails: {
      title: 'Datos del vuelo',
      bookingRef: 'Ref. de reserva',
      flightRef: 'N.º de vuelo',
      flightDate: 'Fecha de vuelo',
      findAFlightButton: 'Encontrar vuelo',
      findClaimButton: 'Encontrar los datos de mi reclamación',
      incidentLabel: '¿Se notificó la reclamación en el aeropuerto?',
      pirRefLabel: 'Número PIR (número de referencia del informe)',
      pirRef: 'PIR',
      dateReported: 'Fecha de notificación',
      flightFinderInProgress: 'Encontrando el vuelo…',
      flightClaimInProgress: 'Encontrando la reclamación...',
      findClaimErrorHeading: 'No pudimos encontrar los datos de su reclamación',
      findClaimErrorMessage: 'Por favor, compruebe los datos anteriores e inténtelo de nuevo. Si no puede encontrar los datos de su reclamación, todavía puede enviar manualmente el formulario siguiente.',
      findClaimSuccessHeading: 'Su reclamación se encontró con éxito',
      findClaimSuccessMessage: 'Por favor, continúe para enviar su reclamación a continuación',
      flightFinderSuccessHeading: 'Salida',
      flightFinderSuccessMessageJoiner: 'a',
      flightFinderErrorIconAlt: 'Error',
      flightFinderErrorHeading: 'No pudimos encontrar su vuelo',
      flightFinderErrorMessage: 'Compruebe los datos anteriores e inténtelo de nuevo. Si no puede encontrar su vuelo, todavía puede enviar estos datos, pero esto puede resultar en un periodo de reclamación más lento',
      flightFinderErrorCheckboxLabel: 'Enviar mi reclamación utilizando los datos indicados anteriormente',
      clearFlightFinderIconAlt: 'Eliminar',
      clearFlightFinderMessage: 'Eliminar y buscar otro vuelo',
      arrivalAirport: 'Aeropuerto de llegada',
      departureAirport: 'Aeropuerto de salida',
      workOrderNumber: 'Número de orden de trabajo',
      bookingRefIconAlt: 'Referencia de reserva o número de orden de trabajo',
      bookingRefInfoHeader: 'Referencia de reserva o número de orden de trabajo',
      bookingRefInfoParagraph: 'Algunas compañías aéreas pueden darle un número de orden de trabajo en lugar de una referencia de reserva.'
    },
    addClaimsItem: {
      title: 'Añadir un artículo dañado',
      itemTypeLabel: 'Tipo de reclamación',
      baggageButton: 'Equipaje',
      contentsButton: 'Contenidos',
      addToClaimButton: 'Añadir a la reclamación',
      saveToClaimButton: 'Guardar'
    },
    replacementItem: {
      title: 'Indemnización',
      notRepairable: 'Parece que el daño no es reparable.',
      chooseReplacement: 'Por favor, elija una sustitución:',
      noReplacementText: 'No hay sustitución, solicite hablar con un agente en su lugar. Esto puede resultar en un periodo de reclamación más lento.',
      noReplacementOptions: 'Lamentablemente, no se han encontrado opciones de sustitución para este artículo de equipaje. Un agente considerará la sustitución o reparación de su artículo de equipaje más adelante.',
      chooseReplacementColour: 'Elija su color preferido.',
      chooseReplacementAltColour: 'Seleccione otros colores que aceptaría.',
      disclaimerHeader: 'Aviso legal',
      additionalInfo: 'Si desea darnos más detalles, en la página siguiente encontrará un recuadro para comentarios.',
      disclaimerText: 'Esta es una representación del equipaje que recibirá. Aunque se ofrecerán todas las funcionalidades que ve, puede haber algunos cambios en el aspecto y diseño.',
      advisoryText: 'Tenga en cuenta que el reemplazo que ha seleccionado puede estar sujeto a cambios si nuestro equipo experto considera que hay un reemplazo más adecuado para su artículo dañado. '
    },
    baggageItem: {
      type: 'Tipo',
      tagNumber: 'N.º de etiqueta del equipaje',
      brand: 'Nombre de la marca',
      colour: 'Color',
      dimensionsIllustration: 'Mida por favor su maleta desde la parte inferior a la superior (incluidas las ruedas).',
      dimensionsInfoIconAlt: 'Información de las dimensiones',
      dimensionsBaggageIconAlt: 'Diagrama de dimensiones del equipaje',
      height: 'Altura (cm)',
      length: 'Longitud (cm)',
      material: 'Material',
      proofOfDamagesTitle: 'Prueba de los daños',
      costTitle: 'Coste original',
      datePurchased: 'Fecha de compra',
      receiptNote: 'Añadir un recibo ayuda a tramitar la reclamación más rápido.',
      receiptButton: 'Subir recibo',
      wheels: 'Ruedas',
      locks: 'Candados',
      morePhotos: 'Añadir más fotos',
      wholeCaseUpload: 'Foto mostrando toda la maleta o bolsa',
      wholeCaseUploadBuggyType: 'Foto que muestre el artículo completo',
      badgeUpload: 'Foto mostrando la etiqueta de la maleta o bolsa',
      badgeUploadBuggyType: 'Foto que muestre el distintivo del artículo',
      baggageTagUpload: 'Foto que muestre la etiqueta del equipaje',
      areaOfDamageUpload: {
        caption: 'Una foto de cada zona de daños',
        selectPlaceholder: 'Seleccionar daños',
        selectOptions: {
          top: 'Parte superior',
          bottom: 'Parte inferior',
          left: 'Izquierda',
          right: 'Derecha'
        }
      },
      price: 'Precio',
      isExpandable: '¿Es el artículo expandible?',
      damageType: 'Tipo de daños',
      model: 'Modelo',
      serialNumber: 'Número de serie'
    },
    contentsItem: {
      name: 'Artículo dañado',
      damageDesc: 'Daños acaecidos',
      proofOfDamagesTitle: 'Prueba de los daños',
      costTitle: 'Coste original',
      datePurchased: 'Fecha de compra',
      receiptNote: 'Añadir un recibo ayuda a tramitar la reclamación más rápido.',
      receiptButton: 'Subir recibo',
      morePhotos: 'Añadir más fotos',
      wholeItemUpload: 'Foto mostrando todo el artículo dañado',
      areaOfDamageUpload: {
        caption: 'Foto mostrando todo el artículo dañado',
        selectPlaceholder: 'Seleccionar los daños',
        selectOptions: {
          top: 'Parte superior',
          bottom: 'Parte inferior',
          left: 'Izquierda',
          right: 'Derecha'
        }
      }
    },
    claimsItemsSummary: {
      title: 'Artículo existentes',
      deleteItemTitle: 'Confirmar eliminación del artículo',
      deleteConfirmationMessage: '¿Está seguro de que quiere eliminarlo?',
      addButton: 'Agregar artículo'
    },
    claimsItem: {
      photo: 'Foto',
      photos: 'Fotos',
      receipt: 'Recibo añadido',
      receipts: 'Recibos añadidos',
      deleteItem: 'Eliminar artículo',
      editItem: 'Editar artículo'
    },
    submitClaim: {
      title: 'Enviar reclamación',
      additionalInfo: 'Información adicional',
      additionalInfoPlaceholder: 'Por favor facilítenos cualquier información adicional sobre esta reclamación que quiere que consideremos.',
      termsCheckboxLabelPrefix: 'Estoy de acuerdo con los',
      termsCheckboxLabel: 'términos y condiciones.',
      infoConfirmationCheckboxLabel: 'Confirmo que toda la información que he facilitado es correcta.',
      submitClaimButton: 'Enviar reclamación',
      submitClaimError: 'Error de envío. Por favor inténtelo de nuevo.',
      whatsNextTitle: '¿Qué es lo siguiente?',
      keepLuggageLabelPrefix: 'Le rogamos que se asegure',
      keepLuggageLabel: 'de no tirar el equipaje dañado',
      keepLuggageLabelSuffix: 'ya que le requeriremos que aporte pruebas fotográficas.',
      waitForConfirmationLabel: 'Una vez que haya presentado su reclamación, nuestro equipo se pondrá en contacto para confirmar los siguientes pasos y las pruebas necesarias.',
      infoIconAlt: 'Información del signo de exclamación',
      requiredBaggageIconAlt: 'Hacen falta fotos del equipaje'
    },
    submitSuccess: {
      title: 'Reclamación enviada',
      header: 'Gracias por enviar una reclamación',
      text: 'Su solicitud de reclamación se está tramitando ahora.',
      refNumber: 'Su número de referencia es',
      emailSoon: 'Pronto recibirá un correo electrónico confirmando el paso siguiente.',
      buttonText: 'Página de inicio',
      pageWillCloseTitle: 'Esta página se cerrará automáticamente en',
      pageWillCloseSeconds: 'segundos'
    },
    makeDelayedClaim: {
      title: 'Reclamar el equipaje retrasado',
      header: 'Escanee el código QR que aparece a continuación y rellene el formulario.',
      buttonText: 'Volver al inicio',
    },
    claimStatus: {
      title: 'Estado de la reclamación',
      statusPageTitle: 'Resumen de su reclamación',
      messagesPageTitle: 'Your claim messages',
      claimUpdateItemTitle: 'Añadir imágenes necesarias',
      summaryHeader: 'Resumen de la reclamación',
      help: 'Si necesita ayuda, conteste o póngase en contacto con nosotros en www.damagedluggage.com a través del chat en directo.',
      phoneIconAlt: 'Ayuda',
      missingDataIconAlt: 'Error',
      missingDataHeading: 'Le rogamos que complete la información que falta',
      missingDataMessage: 'Necesitamos algo más de información con el fin de tramitar su reclamación para los siguientes artículos:',
      updateClaimButton: 'Actualizar la reclamación',
      errorHeader: 'Error al cargar',
      errorMessage: 'Ocurrió un error al intentar cargar su estado de la reclamación. Por favor inténtelo de nuevo.',
      claimRef: 'Referencia de la reclamación',
      claimMade: 'Fecha en la que se hizo la reclamación',
      flightDate: 'Fecha del vuelo',
      baggageItems: 'Artículos de equipaje',
      itemNoMissingData: 'A este artículo no le faltan datos.',
      replacementItemsRequiresConfirmation: 'Confirmar los artículos de sustitución',
      replacementItemsRequiresConfirmationMessage: 'Por favor confirme los artículos de sustitución.',
      claimStatusUpdate: 'Actualización del estado de la reclamación',
      replacementItemsConfirmation: {
        title: 'Artículos de sustitución',
        singleItemReplacement: 'Por favor revise la siguiente sustitución',
        multipleItemReplacement: 'Por favor revise las siguientes sustituciones',
        confirmText: 'Confirme la oferta.',
        declineText: 'Rechace la oferta. Hable mejor con un agente.',
        declineModalTitle: 'Rechazar',
        declineModalText: '¿Podría dar un motivo?',
        declineModalWarning: 'Rechazar esta sustitución puede resultar en un plazo de respuesta de la reclamación más lento.',
        confirmButtonText: 'Confirmar',
        declineButtonText: 'Rechazar'
      },
      actionRequiredTitle: 'Acción necesaria',
      actionRequiredText: 'Necesitamos más información con el fin de continuar tramitando su reclamación.',
      titleMessages: 'Último mensaje',
      viewMessages: 'Mensajes',
      newMessage: 'Responder',
      noMessages: 'No se han añadido mensajes a su reclamación. Vuelva a comprobar pronto.',
      messageClientPrefix: 'Usted',
      messageAdminPrefix: 'Equipo de equipaje dañado',
      newMessageModalTitle: 'Nuevo mensaje',
      newMessageModalSendButton: 'Enviar',
      titleDocuments: 'Subir un documento',
      sendDocument: 'Enviar documento'
    },
    postcodeLookup: {
      errorMessages: {
        invalid: 'Formato de código postal inválido, por favor inténtelo de nuevo',
        notFound: 'No se puede encontrar el código postal, por favor inténtelo de nuevo'
      },
      defaults: {
        buttonText: 'Encontrar dirección',
        placeholder: 'Código postal'
      }
    },
    verification: {
      pageTitle: 'Verificación',
      verificationCode: 'Código de verificación',
      sendNewVerificationCode: '¿Necesita un nuevo código de verificación?',
      newCodeSuccess: 'Por favor, compruebe su correo electrónico.',
      newCodeFailed: 'Error, por favor, inténtelo de nuevo.'
    },
    screensaver: {
      title: 'Informe de equipaje retrasado o dañado.',
      selectLanguage: 'Seleccione el idioma',
      getStarted: 'Empezar'
    },
    apiTranslations: {
      'An invalid code has been entered too many times.\nPlease request a new code and try again.': 'Se ha introducido un código inválido demasiadas veces.\nSolicite un nuevo código e inténtelo de nuevo.',
      'Buggy': 'Buggy',
      'Claim not found.\nPlease contact support for help.': 'No se ha encontrado la reclamación. \nPóngase en contacto con el servicio de asistencia para obtener ayuda.',
      'Golf Travel Bag': 'Golf Travel Bag',
      'Hard Shell Golf Case': 'Hard Shell Golf Case',
      'Hard Shell Traditional Style Case': 'Hard Shell Traditional Style Case ',
      'Hard Shell Trolley Suitcase': 'Hard Shell Trolley Suitcase',
      'Holdall': 'Holdall',
      'Missing claim identifier.\nPlease contact support for help.': 'Falta el identificador de la reclamación.\nPóngase en contacto con el servicio de asistencia para obtener ayuda.',
      'Missing verification code.\nPlease contact support for help.': 'Falta el código de verificación.\nPóngase en contacto con el servicio de asistencia para obtener ayuda.',
      'Our records show your claim to now be resolved.  You can still get in touch with a message below if you need us.': 'Nuestros registros muestran que su reclamación ya está resuelta.  Todavía puede ponerse en contacto con un mensaje a continuación si nos necesita.',
      'Please respond to the below message to progress your claim.': 'Por favor, responda al siguiente mensaje para tramitar su reclamación.',
      'RuckSack': 'RuckSack',
      'Soft Shell Trolley Suitcase': 'Soft Shell Trolley Suitcase',
      'This claim has been closed.\nPlease contact support for help.': 'Esta reclamación se ha cerrado. /nPóngase en contacto con el servicio de asistencia para obtener ayuda.',
      'This code has now expired.\nPlease request a new code and try again.': 'Este código ha caducado.\nSolicite un nuevo código e inténtelo de nuevo.',
      'This code is unrecognised.\nPlease double check your code or request a new code and try again.': 'No se reconoce este código.\nCompruebe su código o solicite uno nuevo e inténtelo de nuevo.',
      'Your claim has been passed to our accounts team.  We aim to process payments within 14 working days where possible.': 'Su reclamación se ha transmitido a nuestro equipo de contabilidad.  Nuestro objetivo es procesar los pagos en un plazo de 14 días laborables siempre que sea posible.',
      'Your claim has been rejected as your claim was submitted more than 7 days after the damage date.': 'Su reclamación ha sido rechazada porque se presentó más de 7 días después de la fecha del daño.',
      'Your claim has been rejected.': 'Su reclamación ha sido rechazada.',
      'Your claim is being handled by our warehouse team who are getting your item ready for despatch.': 'Nuestro equipo de almacén se está encargando de su reclamación y está preparando su artículo para el envío.',
      'Your claim is being reviewed, we will be in touch when we have an update for you.': 'Su reclamación está siendo revisada, nos pondremos en contacto con usted cuando tengamos una actualización.',
      'Your item has been despatched.': 'Su artículo ha sido enviado.',
      'Your replacement bag is currently out of stock. There is no need for you to do anything at this time we will send your luggage as soon as it is in stock.': 'Su bolsa de reemplazo está actualmente fuera de stock. No es necesario que haga nada en este momento, le enviaremos su equipaje tan pronto como esté en stock.'
    }
  }
}
export default messages



//////////////////
// WEBPACK FOOTER
// ./static/theme/languages/es.js
// module id = 326
// module chunks = 4